import { darkColors } from "../../../data/SampleData";
export const DarkGroups = {
  "00a": {
    shape: "circularImage",
    size: 60,
    mass: 15,
    font: {
      size: 0,
    },
  },
  "01a": {
    color: {
      background: darkColors.filter((k) => k.category === "category91a")[0].background,
      border: darkColors.filter((k) => k.category === "category91a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category91a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category91a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category91a")[0].color,
      size: darkColors.filter((k) => k.category === "category91a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category91a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "01adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category91a")[0].background,
      border: darkColors.filter((k) => k.category === "category91a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category91a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category91a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category91a")[0].color,
      size: darkColors.filter((k) => k.category === "category91a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category91a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },

  "01b": {
    color: {
      background: darkColors.filter((k) => k.category === "category91b")[0].background,
      border: darkColors.filter((k) => k.category === "category91b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category91b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category91b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category91b")[0].color,
      size: darkColors.filter((k) => k.category === "category91b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category91b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  //11
  "11a": {
    color: {
      background: darkColors.filter((k) => k.category === "category11a")[0].background,
      border: darkColors.filter((k) => k.category === "category11a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category11a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category11a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category11a")[0].color,
      size: darkColors.filter((k) => k.category === "category11a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category11a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "12a": {
    color: {
      background: darkColors.filter((k) => k.category === "category12a")[0].background,
      border: darkColors.filter((k) => k.category === "category12a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category12a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category12a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category12a")[0].color,
      size: darkColors.filter((k) => k.category === "category12a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category12a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "13a": {
    color: {
      background: darkColors.filter((k) => k.category === "category13a")[0].background,
      border: darkColors.filter((k) => k.category === "category13a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category13a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category13a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category13a")[0].color,
      size: darkColors.filter((k) => k.category === "category13a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category13a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "14a": {
    color: {
      background: darkColors.filter((k) => k.category === "category14a")[0].background,
      border: darkColors.filter((k) => k.category === "category14a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category14a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category14a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category14a")[0].color,
      size: darkColors.filter((k) => k.category === "category14a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category14a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "15a": {
    color: {
      background: darkColors.filter((k) => k.category === "category15a")[0].background,
      border: darkColors.filter((k) => k.category === "category15a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category15a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category15a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category15a")[0].color,
      size: darkColors.filter((k) => k.category === "category15a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category15a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "16a": {
    color: {
      background: darkColors.filter((k) => k.category === "category16a")[0].background,
      border: darkColors.filter((k) => k.category === "category16a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category16a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category16a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category16a")[0].color,
      size: darkColors.filter((k) => k.category === "category16a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category16a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "17a": {
    color: {
      background: darkColors.filter((k) => k.category === "category17a")[0].background,
      border: darkColors.filter((k) => k.category === "category17a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category17a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category17a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category17a")[0].color,
      size: darkColors.filter((k) => k.category === "category17a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category17a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "18a": {
    color: {
      background: darkColors.filter((k) => k.category === "category18a")[0].background,
      border: darkColors.filter((k) => k.category === "category18a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category18a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category18a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category18a")[0].color,
      size: darkColors.filter((k) => k.category === "category18a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category18a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //21
  "21a": {
    color: {
      background: darkColors.filter((k) => k.category === "category21a")[0].background,
      border: darkColors.filter((k) => k.category === "category21a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category21a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category21a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category21a")[0].color,
      size: darkColors.filter((k) => k.category === "category21a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category21a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "22a": {
    color: {
      background: darkColors.filter((k) => k.category === "category22a")[0].background,
      border: darkColors.filter((k) => k.category === "category22a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category22a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category22a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category22a")[0].color,
      size: darkColors.filter((k) => k.category === "category22a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category22a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "23a": {
    color: {
      background: darkColors.filter((k) => k.category === "category23a")[0].background,
      border: darkColors.filter((k) => k.category === "category23a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category23a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category23a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category23a")[0].color,
      size: darkColors.filter((k) => k.category === "category23a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category23a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "24a": {
    color: {
      background: darkColors.filter((k) => k.category === "category24a")[0].background,
      border: darkColors.filter((k) => k.category === "category24a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category24a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category24a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category24a")[0].color,
      size: darkColors.filter((k) => k.category === "category24a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category24a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "25a": {
    color: {
      background: darkColors.filter((k) => k.category === "category25a")[0].background,
      border: darkColors.filter((k) => k.category === "category25a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category25a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category25a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category25a")[0].color,
      size: darkColors.filter((k) => k.category === "category25a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category25a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "26a": {
    color: {
      background: darkColors.filter((k) => k.category === "category26a")[0].background,
      border: darkColors.filter((k) => k.category === "category26a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category26a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category26a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category26a")[0].color,
      size: darkColors.filter((k) => k.category === "category26a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category26a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "27a": {
    color: {
      background: darkColors.filter((k) => k.category === "category27a")[0].background,
      border: darkColors.filter((k) => k.category === "category27a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category27a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category27a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category27a")[0].color,
      size: darkColors.filter((k) => k.category === "category27a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category27a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "28a": {
    color: {
      background: darkColors.filter((k) => k.category === "category28a")[0].background,
      border: darkColors.filter((k) => k.category === "category28a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category28a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category28a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category28a")[0].color,
      size: darkColors.filter((k) => k.category === "category28a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category28a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //31
  "31a": {
    color: {
      background: darkColors.filter((k) => k.category === "category31a")[0].background,
      border: darkColors.filter((k) => k.category === "category31a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category31a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category31a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category31a")[0].color,
      size: darkColors.filter((k) => k.category === "category31a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category31a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "32a": {
    color: {
      background: darkColors.filter((k) => k.category === "category32a")[0].background,
      border: darkColors.filter((k) => k.category === "category32a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category22a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category32a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category32a")[0].color,
      size: darkColors.filter((k) => k.category === "category32a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category32a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "33a": {
    color: {
      background: darkColors.filter((k) => k.category === "category33a")[0].background,
      border: darkColors.filter((k) => k.category === "category33a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category33a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category33a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category33a")[0].color,
      size: darkColors.filter((k) => k.category === "category33a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category33a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "34a": {
    color: {
      background: darkColors.filter((k) => k.category === "category34a")[0].background,
      border: darkColors.filter((k) => k.category === "category34a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category34a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category34a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category34a")[0].color,
      size: darkColors.filter((k) => k.category === "category34a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category34a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "35a": {
    color: {
      background: darkColors.filter((k) => k.category === "category35a")[0].background,
      border: darkColors.filter((k) => k.category === "category35a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category35a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category35a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category35a")[0].color,
      size: darkColors.filter((k) => k.category === "category35a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category35a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "36a": {
    color: {
      background: darkColors.filter((k) => k.category === "category36a")[0].background,
      border: darkColors.filter((k) => k.category === "category36a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category36a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category36a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category36a")[0].color,
      size: darkColors.filter((k) => k.category === "category36a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category36a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "37a": {
    color: {
      background: darkColors.filter((k) => k.category === "category37a")[0].background,
      border: darkColors.filter((k) => k.category === "category37a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category37a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category37a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category37a")[0].color,
      size: darkColors.filter((k) => k.category === "category37a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category37a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "38a": {
    color: {
      background: darkColors.filter((k) => k.category === "category38a")[0].background,
      border: darkColors.filter((k) => k.category === "category38a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category38a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category38a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category38a")[0].color,
      size: darkColors.filter((k) => k.category === "category38a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category38a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },

  "41a": {
    color: {
      background: darkColors.filter((k) => k.category === "category41a")[0].background,
      border: darkColors.filter((k) => k.category === "category41a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category41a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category41a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category41a")[0].color,
      size: darkColors.filter((k) => k.category === "category41a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category41a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "42a": {
    color: {
      background: darkColors.filter((k) => k.category === "category42a")[0].background,
      border: darkColors.filter((k) => k.category === "category42a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category42a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category42a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category42a")[0].color,
      size: darkColors.filter((k) => k.category === "category42a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category42a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "43a": {
    color: {
      background: darkColors.filter((k) => k.category === "category43a")[0].background,
      border: darkColors.filter((k) => k.category === "category43a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category43a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category43a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category43a")[0].color,
      size: darkColors.filter((k) => k.category === "category43a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category43a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "44a": {
    color: {
      background: darkColors.filter((k) => k.category === "category44a")[0].background,
      border: darkColors.filter((k) => k.category === "category44a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category44a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category44a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category44a")[0].color,
      size: darkColors.filter((k) => k.category === "category44a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category44a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "45a": {
    color: {
      background: darkColors.filter((k) => k.category === "category45a")[0].background,
      border: darkColors.filter((k) => k.category === "category45a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category45a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category45a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category45a")[0].color,
      size: darkColors.filter((k) => k.category === "category45a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category45a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "46a": {
    color: {
      background: darkColors.filter((k) => k.category === "category46a")[0].background,
      border: darkColors.filter((k) => k.category === "category46a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category46a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category46a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category46a")[0].color,
      size: darkColors.filter((k) => k.category === "category46a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category46a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "47a": {
    color: {
      background: darkColors.filter((k) => k.category === "category47a")[0].background,
      border: darkColors.filter((k) => k.category === "category47a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category47a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category47a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category47a")[0].color,
      size: darkColors.filter((k) => k.category === "category47a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category47a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "48a": {
    color: {
      background: darkColors.filter((k) => k.category === "category48a")[0].background,
      border: darkColors.filter((k) => k.category === "category48a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category48a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category48a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category48a")[0].color,
      size: darkColors.filter((k) => k.category === "category48a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category48a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //Health2

  "51a": {
    color: {
      background: darkColors.filter((k) => k.category === "category51a")[0].background,
      border: darkColors.filter((k) => k.category === "category51a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category51a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category51a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category51a")[0].color,
      size: darkColors.filter((k) => k.category === "category51a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category51a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "52a": {
    color: {
      background: darkColors.filter((k) => k.category === "category52a")[0].background,
      border: darkColors.filter((k) => k.category === "category52a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category52a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category52a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category52a")[0].color,
      size: darkColors.filter((k) => k.category === "category52a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category52a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "53a": {
    color: {
      background: darkColors.filter((k) => k.category === "category53a")[0].background,
      border: darkColors.filter((k) => k.category === "category53a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category53a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category53a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category53a")[0].color,
      size: darkColors.filter((k) => k.category === "category53a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category53a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "54a": {
    color: {
      background: darkColors.filter((k) => k.category === "category54a")[0].background,
      border: darkColors.filter((k) => k.category === "category54a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category54a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category54a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category54a")[0].color,
      size: darkColors.filter((k) => k.category === "category54a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category54a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "55a": {
    color: {
      background: darkColors.filter((k) => k.category === "category55a")[0].background,
      border: darkColors.filter((k) => k.category === "category55a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category55a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category55a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category55a")[0].color,
      size: darkColors.filter((k) => k.category === "category55a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category55a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "56a": {
    color: {
      background: darkColors.filter((k) => k.category === "category56a")[0].background,
      border: darkColors.filter((k) => k.category === "category56a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category56a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category56a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category56a")[0].color,
      size: darkColors.filter((k) => k.category === "category56a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category56a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "57a": {
    color: {
      background: darkColors.filter((k) => k.category === "category57a")[0].background,
      border: darkColors.filter((k) => k.category === "category57a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category57a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category57a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category57a")[0].color,
      size: darkColors.filter((k) => k.category === "category57a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category57a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "58a": {
    color: {
      background: darkColors.filter((k) => k.category === "category58a")[0].background,
      border: darkColors.filter((k) => k.category === "category58a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category58a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category58a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category58a")[0].color,
      size: darkColors.filter((k) => k.category === "category58a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category58a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //Fitness
  "61a": {
    color: {
      background: darkColors.filter((k) => k.category === "category61a")[0].background,
      border: darkColors.filter((k) => k.category === "category61a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category61a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category61a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category61a")[0].color,
      size: darkColors.filter((k) => k.category === "category61a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category61a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "62a": {
    color: {
      background: darkColors.filter((k) => k.category === "category62a")[0].background,
      border: darkColors.filter((k) => k.category === "category62a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category62a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category62a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category62a")[0].color,
      size: darkColors.filter((k) => k.category === "category62a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category62a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "63a": {
    color: {
      background: darkColors.filter((k) => k.category === "category63a")[0].background,
      border: darkColors.filter((k) => k.category === "category63a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category63a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category63a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category63a")[0].color,
      size: darkColors.filter((k) => k.category === "category63a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category63a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "64a": {
    color: {
      background: darkColors.filter((k) => k.category === "category64a")[0].background,
      border: darkColors.filter((k) => k.category === "category64a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category64a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category64a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category64a")[0].color,
      size: darkColors.filter((k) => k.category === "category64a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category64a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "65a": {
    color: {
      background: darkColors.filter((k) => k.category === "category65a")[0].background,
      border: darkColors.filter((k) => k.category === "category65a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category65a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category65a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category65a")[0].color,
      size: darkColors.filter((k) => k.category === "category65a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category65a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "66a": {
    color: {
      background: darkColors.filter((k) => k.category === "category66a")[0].background,
      border: darkColors.filter((k) => k.category === "category66a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category66a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category66a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category66a")[0].color,
      size: darkColors.filter((k) => k.category === "category66a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category66a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "67a": {
    color: {
      background: darkColors.filter((k) => k.category === "category67a")[0].background,
      border: darkColors.filter((k) => k.category === "category67a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category67a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category67a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category67a")[0].color,
      size: darkColors.filter((k) => k.category === "category67a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category67a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "68a": {
    color: {
      background: darkColors.filter((k) => k.category === "category68a")[0].background,
      border: darkColors.filter((k) => k.category === "category68a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category68a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category68a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category68a")[0].color,
      size: darkColors.filter((k) => k.category === "category68a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category68a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //Biometric
  "71a": {
    color: {
      background: darkColors.filter((k) => k.category === "category71a")[0].background,
      border: darkColors.filter((k) => k.category === "category71a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category71a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category71a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category71a")[0].color,
      size: darkColors.filter((k) => k.category === "category71a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category71a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "72a": {
    color: {
      background: darkColors.filter((k) => k.category === "category72a")[0].background,
      border: darkColors.filter((k) => k.category === "category72a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category72a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category72a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category72a")[0].color,
      size: darkColors.filter((k) => k.category === "category72a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category72a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "73a": {
    color: {
      background: darkColors.filter((k) => k.category === "category73a")[0].background,
      border: darkColors.filter((k) => k.category === "category73a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category73a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category73a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category73a")[0].color,
      size: darkColors.filter((k) => k.category === "category73a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category73a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "74a": {
    color: {
      background: darkColors.filter((k) => k.category === "category74a")[0].background,
      border: darkColors.filter((k) => k.category === "category74a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category74a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category74a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category74a")[0].color,
      size: darkColors.filter((k) => k.category === "category74a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category74a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "75a": {
    color: {
      background: darkColors.filter((k) => k.category === "category75a")[0].background,
      border: darkColors.filter((k) => k.category === "category75a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category75a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category75a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category75a")[0].color,
      size: darkColors.filter((k) => k.category === "category75a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category75a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "76a": {
    color: {
      background: darkColors.filter((k) => k.category === "category76a")[0].background,
      border: darkColors.filter((k) => k.category === "category76a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category76a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category76a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category76a")[0].color,
      size: darkColors.filter((k) => k.category === "category76a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category76a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "77a": {
    color: {
      background: darkColors.filter((k) => k.category === "category77a")[0].background,
      border: darkColors.filter((k) => k.category === "category77a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category77a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category77a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category77a")[0].color,
      size: darkColors.filter((k) => k.category === "category77a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category77a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "78a": {
    color: {
      background: darkColors.filter((k) => k.category === "category78a")[0].background,
      border: darkColors.filter((k) => k.category === "category78a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category78a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category78a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category78a")[0].color,
      size: darkColors.filter((k) => k.category === "category78a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category78a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //Location
  "81a": {
    color: {
      background: darkColors.filter((k) => k.category === "category81a")[0].background,
      border: darkColors.filter((k) => k.category === "category81a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category81a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category81a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category81a")[0].color,
      size: darkColors.filter((k) => k.category === "category81a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category81a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "82a": {
    color: {
      background: darkColors.filter((k) => k.category === "category82a")[0].background,
      border: darkColors.filter((k) => k.category === "category82a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category82a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category82a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category82a")[0].color,
      size: darkColors.filter((k) => k.category === "category82a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category82a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "83a": {
    color: {
      background: darkColors.filter((k) => k.category === "category83a")[0].background,
      border: darkColors.filter((k) => k.category === "category83a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category83a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category83a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category83a")[0].color,
      size: darkColors.filter((k) => k.category === "category83a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category83a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "84a": {
    color: {
      background: darkColors.filter((k) => k.category === "category84a")[0].background,
      border: darkColors.filter((k) => k.category === "category84a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category84a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category84a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category84a")[0].color,
      size: darkColors.filter((k) => k.category === "category84a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category84a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "85a": {
    color: {
      background: darkColors.filter((k) => k.category === "category85a")[0].background,
      border: darkColors.filter((k) => k.category === "category85a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category85a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category85a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category85a")[0].color,
      size: darkColors.filter((k) => k.category === "category85a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category85a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "86a": {
    color: {
      background: darkColors.filter((k) => k.category === "category86a")[0].background,
      border: darkColors.filter((k) => k.category === "category86a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category86a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category86a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category86a")[0].color,
      size: darkColors.filter((k) => k.category === "category86a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category86a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "87a": {
    color: {
      background: darkColors.filter((k) => k.category === "category87a")[0].background,
      border: darkColors.filter((k) => k.category === "category87a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category87a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category87a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category87a")[0].color,
      size: darkColors.filter((k) => k.category === "category87a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category87a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "88a": {
    color: {
      background: darkColors.filter((k) => k.category === "category88a")[0].background,
      border: darkColors.filter((k) => k.category === "category88a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category88a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category88a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category88a")[0].color,
      size: darkColors.filter((k) => k.category === "category88a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category88a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },

  //dataOwnerUploaded
  "91a": {
    color: {
      background: darkColors.filter((k) => k.category === "category91a")[0].background,
      border: darkColors.filter((k) => k.category === "category91a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category91a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category91a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category91a")[0].color,
      size: darkColors.filter((k) => k.category === "category91a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category91a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "92a": {
    color: {
      background: darkColors.filter((k) => k.category === "category92a")[0].background,
      border: darkColors.filter((k) => k.category === "category92a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category92a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category92a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category92a")[0].color,
      size: darkColors.filter((k) => k.category === "category92a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category92a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "93a": {
    color: {
      background: darkColors.filter((k) => k.category === "category93a")[0].background,
      border: darkColors.filter((k) => k.category === "category93a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category93a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category93a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category93a")[0].color,
      size: darkColors.filter((k) => k.category === "category93a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category93a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "94a": {
    color: {
      background: darkColors.filter((k) => k.category === "category94a")[0].background,
      border: darkColors.filter((k) => k.category === "category94a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category94a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category94a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category94a")[0].color,
      size: darkColors.filter((k) => k.category === "category94a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category94a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "95a": {
    color: {
      background: darkColors.filter((k) => k.category === "category95a")[0].background,
      border: darkColors.filter((k) => k.category === "category95a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category95a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category95a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category95a")[0].color,
      size: darkColors.filter((k) => k.category === "category95a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category95a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "96a": {
    color: {
      background: darkColors.filter((k) => k.category === "category96a")[0].background,
      border: darkColors.filter((k) => k.category === "category96a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category96a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category96a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category96a")[0].color,
      size: darkColors.filter((k) => k.category === "category96a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category96a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "97a": {
    color: {
      background: darkColors.filter((k) => k.category === "category97a")[0].background,
      border: darkColors.filter((k) => k.category === "category97a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category97a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category97a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category97a")[0].color,
      size: darkColors.filter((k) => k.category === "category97a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category97a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "98a": {
    color: {
      background: darkColors.filter((k) => k.category === "category98a")[0].background,
      border: darkColors.filter((k) => k.category === "category98a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category98a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category98a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category98a")[0].color,
      size: darkColors.filter((k) => k.category === "category98a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category98a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  "99a": {
    color: {
      background: darkColors.filter((k) => k.category === "category98a")[0].background,
      border: darkColors.filter((k) => k.category === "category98a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category98a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category98a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category98a")[0].color,
      size: darkColors.filter((k) => k.category === "category98a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category98a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },

  //11
  "11b": {
    color: {
      background: darkColors.filter((k) => k.category === "category11b")[0].background,
      border: darkColors.filter((k) => k.category === "category11b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category11b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category11b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category11b")[0].color,
      size: darkColors.filter((k) => k.category === "category11b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category11b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "12b": {
    color: {
      background: darkColors.filter((k) => k.category === "category12b")[0].background,
      border: darkColors.filter((k) => k.category === "category12b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category12b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category12b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category12b")[0].color,
      size: darkColors.filter((k) => k.category === "category12b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category12b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "13b": {
    color: {
      background: darkColors.filter((k) => k.category === "category13b")[0].background,
      border: darkColors.filter((k) => k.category === "category13b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category13b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category13b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category13b")[0].color,
      size: darkColors.filter((k) => k.category === "category13b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category13b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "14b": {
    color: {
      background: darkColors.filter((k) => k.category === "category14b")[0].background,
      border: darkColors.filter((k) => k.category === "category14b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category14b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category14b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category14b")[0].color,
      size: darkColors.filter((k) => k.category === "category14b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category14b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "15b": {
    color: {
      background: darkColors.filter((k) => k.category === "category15b")[0].background,
      border: darkColors.filter((k) => k.category === "category15b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category15b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category15b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category15b")[0].color,
      size: darkColors.filter((k) => k.category === "category15b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category15b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "16b": {
    color: {
      background: darkColors.filter((k) => k.category === "category16b")[0].background,
      border: darkColors.filter((k) => k.category === "category16b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category16b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category16b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category16b")[0].color,
      size: darkColors.filter((k) => k.category === "category16b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category16b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "17b": {
    color: {
      background: darkColors.filter((k) => k.category === "category17b")[0].background,
      border: darkColors.filter((k) => k.category === "category17b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category17b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category17b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category17b")[0].color,
      size: darkColors.filter((k) => k.category === "category17b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category17b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "18b": {
    color: {
      background: darkColors.filter((k) => k.category === "category18b")[0].background,
      border: darkColors.filter((k) => k.category === "category18b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category18b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category18b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category18b")[0].color,
      size: darkColors.filter((k) => k.category === "category18b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category18b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //21
  "21b": {
    color: {
      background: darkColors.filter((k) => k.category === "category21b")[0].background,
      border: darkColors.filter((k) => k.category === "category21b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category21b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category21b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category21b")[0].color,
      size: darkColors.filter((k) => k.category === "category21b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category21b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "22b": {
    color: {
      background: darkColors.filter((k) => k.category === "category22b")[0].background,
      border: darkColors.filter((k) => k.category === "category22b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category22b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category22b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category22b")[0].color,
      size: darkColors.filter((k) => k.category === "category22b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category22b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "23b": {
    color: {
      background: darkColors.filter((k) => k.category === "category23b")[0].background,
      border: darkColors.filter((k) => k.category === "category23b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category23b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category23b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category23b")[0].color,
      size: darkColors.filter((k) => k.category === "category23b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category23b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "24b": {
    color: {
      background: darkColors.filter((k) => k.category === "category24b")[0].background,
      border: darkColors.filter((k) => k.category === "category24b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category24b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category24b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category24b")[0].color,
      size: darkColors.filter((k) => k.category === "category24b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category24b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "25b": {
    color: {
      background: darkColors.filter((k) => k.category === "category25b")[0].background,
      border: darkColors.filter((k) => k.category === "category25b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category25b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category25b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category25b")[0].color,
      size: darkColors.filter((k) => k.category === "category25b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category25b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "26b": {
    color: {
      background: darkColors.filter((k) => k.category === "category26b")[0].background,
      border: darkColors.filter((k) => k.category === "category26b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category26b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category26b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category26b")[0].color,
      size: darkColors.filter((k) => k.category === "category26b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category26b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "27b": {
    color: {
      background: darkColors.filter((k) => k.category === "category27b")[0].background,
      border: darkColors.filter((k) => k.category === "category27b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category27b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category27b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category27b")[0].color,
      size: darkColors.filter((k) => k.category === "category27b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category27b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "28b": {
    color: {
      background: darkColors.filter((k) => k.category === "category28b")[0].background,
      border: darkColors.filter((k) => k.category === "category28b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category28b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category28b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category28b")[0].color,
      size: darkColors.filter((k) => k.category === "category28b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category28b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //31
  "31b": {
    color: {
      background: darkColors.filter((k) => k.category === "category31b")[0].background,
      border: darkColors.filter((k) => k.category === "category31b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category31b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category31b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category31b")[0].color,
      size: darkColors.filter((k) => k.category === "category31b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category31b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "32b": {
    color: {
      background: darkColors.filter((k) => k.category === "category32b")[0].background,
      border: darkColors.filter((k) => k.category === "category32b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category32b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category32b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category32b")[0].color,
      size: darkColors.filter((k) => k.category === "category32b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category32b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "33b": {
    color: {
      background: darkColors.filter((k) => k.category === "category33b")[0].background,
      border: darkColors.filter((k) => k.category === "category33b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category33b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category33b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category33b")[0].color,
      size: darkColors.filter((k) => k.category === "category33b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category33b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "34b": {
    color: {
      background: darkColors.filter((k) => k.category === "category34b")[0].background,
      border: darkColors.filter((k) => k.category === "category34b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category34b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category34b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category34b")[0].color,
      size: darkColors.filter((k) => k.category === "category34b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category34b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "35b": {
    color: {
      background: darkColors.filter((k) => k.category === "category35b")[0].background,
      border: darkColors.filter((k) => k.category === "category35b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category35b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category35b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category35b")[0].color,
      size: darkColors.filter((k) => k.category === "category35b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category35b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "36b": {
    color: {
      background: darkColors.filter((k) => k.category === "category36b")[0].background,
      border: darkColors.filter((k) => k.category === "category36b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category36b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category36b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category36b")[0].color,
      size: darkColors.filter((k) => k.category === "category36b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category36b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "37b": {
    color: {
      background: darkColors.filter((k) => k.category === "category37b")[0].background,
      border: darkColors.filter((k) => k.category === "category37b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category37b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category37b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category37b")[0].color,
      size: darkColors.filter((k) => k.category === "category37b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category37b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "38b": {
    color: {
      background: darkColors.filter((k) => k.category === "category38b")[0].background,
      border: darkColors.filter((k) => k.category === "category38b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category38b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category38b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category38b")[0].color,
      size: darkColors.filter((k) => k.category === "category38b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category38b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },

  "41b": {
    color: {
      background: darkColors.filter((k) => k.category === "category41b")[0].background,
      border: darkColors.filter((k) => k.category === "category41b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category41b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category41b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category41b")[0].color,
      size: darkColors.filter((k) => k.category === "category41b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category41b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "42b": {
    color: {
      background: darkColors.filter((k) => k.category === "category42b")[0].background,
      border: darkColors.filter((k) => k.category === "category42b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category42b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category42b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category42b")[0].color,
      size: darkColors.filter((k) => k.category === "category42b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category42b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "43b": {
    color: {
      background: darkColors.filter((k) => k.category === "category43b")[0].background,
      border: darkColors.filter((k) => k.category === "category43b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category43b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category43b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category43b")[0].color,
      size: darkColors.filter((k) => k.category === "category43b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category43b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "44b": {
    color: {
      background: darkColors.filter((k) => k.category === "category44b")[0].background,
      border: darkColors.filter((k) => k.category === "category44b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category44b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category44b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category44b")[0].color,
      size: darkColors.filter((k) => k.category === "category44b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category44b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "45b": {
    color: {
      background: darkColors.filter((k) => k.category === "category45b")[0].background,
      border: darkColors.filter((k) => k.category === "category45b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category45b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category45b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category45b")[0].color,
      size: darkColors.filter((k) => k.category === "category45b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category45b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "46b": {
    color: {
      background: darkColors.filter((k) => k.category === "category46b")[0].background,
      border: darkColors.filter((k) => k.category === "category46b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category46b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category46b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category46b")[0].color,
      size: darkColors.filter((k) => k.category === "category46b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category46b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "47b": {
    color: {
      background: darkColors.filter((k) => k.category === "category47b")[0].background,
      border: darkColors.filter((k) => k.category === "category47b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category47b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category47b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category47b")[0].color,
      size: darkColors.filter((k) => k.category === "category47b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category47b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "48b": {
    color: {
      background: darkColors.filter((k) => k.category === "category48b")[0].background,
      border: darkColors.filter((k) => k.category === "category48b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category48b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category48b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category48b")[0].color,
      size: darkColors.filter((k) => k.category === "category48b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category48b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //Health2

  "51b": {
    color: {
      background: darkColors.filter((k) => k.category === "category51b")[0].background,
      border: darkColors.filter((k) => k.category === "category51b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category51b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category51b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category51b")[0].color,
      size: darkColors.filter((k) => k.category === "category51b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category51b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "52b": {
    color: {
      background: darkColors.filter((k) => k.category === "category52b")[0].background,
      border: darkColors.filter((k) => k.category === "category52b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category52b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category52b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category52b")[0].color,
      size: darkColors.filter((k) => k.category === "category52b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category52b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "53b": {
    color: {
      background: darkColors.filter((k) => k.category === "category53b")[0].background,
      border: darkColors.filter((k) => k.category === "category53b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category53b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category53b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category53b")[0].color,
      size: darkColors.filter((k) => k.category === "category53b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category53b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "54b": {
    color: {
      background: darkColors.filter((k) => k.category === "category54b")[0].background,
      border: darkColors.filter((k) => k.category === "category54b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category54b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category54b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category54b")[0].color,
      size: darkColors.filter((k) => k.category === "category54b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category54b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "55b": {
    color: {
      background: darkColors.filter((k) => k.category === "category55b")[0].background,
      border: darkColors.filter((k) => k.category === "category55b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category55b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category55b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category55b")[0].color,
      size: darkColors.filter((k) => k.category === "category55b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category55b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "56b": {
    color: {
      background: darkColors.filter((k) => k.category === "category56b")[0].background,
      border: darkColors.filter((k) => k.category === "category56b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category56b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category56b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category56b")[0].color,
      size: darkColors.filter((k) => k.category === "category56b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category56b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "57b": {
    color: {
      background: darkColors.filter((k) => k.category === "category57b")[0].background,
      border: darkColors.filter((k) => k.category === "category57b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category57b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category57b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category57b")[0].color,
      size: darkColors.filter((k) => k.category === "category57b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category57b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "58b": {
    color: {
      background: darkColors.filter((k) => k.category === "category58b")[0].background,
      border: darkColors.filter((k) => k.category === "category58b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category58b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category58b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category58b")[0].color,
      size: darkColors.filter((k) => k.category === "category58b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category58b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //Fitness
  "61b": {
    color: {
      background: darkColors.filter((k) => k.category === "category61b")[0].background,
      border: darkColors.filter((k) => k.category === "category61b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category61b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category61b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category61b")[0].color,
      size: darkColors.filter((k) => k.category === "category61b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category61b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "62b": {
    color: {
      background: darkColors.filter((k) => k.category === "category62b")[0].background,
      border: darkColors.filter((k) => k.category === "category62b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category62b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category62b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category62b")[0].color,
      size: darkColors.filter((k) => k.category === "category62b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category62b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "63b": {
    color: {
      background: darkColors.filter((k) => k.category === "category63b")[0].background,
      border: darkColors.filter((k) => k.category === "category63b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category63b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category63b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category63b")[0].color,
      size: darkColors.filter((k) => k.category === "category63b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category63b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "64b": {
    color: {
      background: darkColors.filter((k) => k.category === "category64b")[0].background,
      border: darkColors.filter((k) => k.category === "category64b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category64b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category64b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category64b")[0].color,
      size: darkColors.filter((k) => k.category === "category64b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category64b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "65b": {
    color: {
      background: darkColors.filter((k) => k.category === "category65b")[0].background,
      border: darkColors.filter((k) => k.category === "category65b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category65b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category65b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category65b")[0].color,
      size: darkColors.filter((k) => k.category === "category65b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category65b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "66b": {
    color: {
      background: darkColors.filter((k) => k.category === "category66b")[0].background,
      border: darkColors.filter((k) => k.category === "category66b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category66b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category66b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category66b")[0].color,
      size: darkColors.filter((k) => k.category === "category66b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category66b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "67b": {
    color: {
      background: darkColors.filter((k) => k.category === "category67b")[0].background,
      border: darkColors.filter((k) => k.category === "category67b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category67b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category67b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category67b")[0].color,
      size: darkColors.filter((k) => k.category === "category67b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category67b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "68b": {
    color: {
      background: darkColors.filter((k) => k.category === "category68b")[0].background,
      border: darkColors.filter((k) => k.category === "category68b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category68b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category68b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category68b")[0].color,
      size: darkColors.filter((k) => k.category === "category68b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category68b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //Biometric
  "71b": {
    color: {
      background: darkColors.filter((k) => k.category === "category71b")[0].background,
      border: darkColors.filter((k) => k.category === "category71b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category71b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category71b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category71b")[0].color,
      size: darkColors.filter((k) => k.category === "category71b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category71b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "72b": {
    color: {
      background: darkColors.filter((k) => k.category === "category72b")[0].background,
      border: darkColors.filter((k) => k.category === "category72b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category72b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category72b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category72b")[0].color,
      size: darkColors.filter((k) => k.category === "category72b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category72b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "73b": {
    color: {
      background: darkColors.filter((k) => k.category === "category73b")[0].background,
      border: darkColors.filter((k) => k.category === "category73b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category73b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category73b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category73b")[0].color,
      size: darkColors.filter((k) => k.category === "category73b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category73b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "74b": {
    color: {
      background: darkColors.filter((k) => k.category === "category74b")[0].background,
      border: darkColors.filter((k) => k.category === "category74b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category74b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category74b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category74b")[0].color,
      size: darkColors.filter((k) => k.category === "category74b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category74b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "75b": {
    color: {
      background: darkColors.filter((k) => k.category === "category75b")[0].background,
      border: darkColors.filter((k) => k.category === "category75b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category75b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category75b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category75b")[0].color,
      size: darkColors.filter((k) => k.category === "category75b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category75b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "76b": {
    color: {
      background: darkColors.filter((k) => k.category === "category76b")[0].background,
      border: darkColors.filter((k) => k.category === "category76b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category76b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category76b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category76b")[0].color,
      size: darkColors.filter((k) => k.category === "category76b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category76b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "77b": {
    color: {
      background: darkColors.filter((k) => k.category === "category77b")[0].background,
      border: darkColors.filter((k) => k.category === "category77b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category77b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category77b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category77b")[0].color,
      size: darkColors.filter((k) => k.category === "category77b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category77b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "78b": {
    color: {
      background: darkColors.filter((k) => k.category === "category78b")[0].background,
      border: darkColors.filter((k) => k.category === "category78b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category78b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category78b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category78b")[0].color,
      size: darkColors.filter((k) => k.category === "category78b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category78b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //Location
  "81b": {
    color: {
      background: darkColors.filter((k) => k.category === "category81b")[0].background,
      border: darkColors.filter((k) => k.category === "category81b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category81b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category81b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category81b")[0].color,
      size: darkColors.filter((k) => k.category === "category81b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category81b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "82b": {
    color: {
      background: darkColors.filter((k) => k.category === "category82b")[0].background,
      border: darkColors.filter((k) => k.category === "category82b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category82b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category82b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category82b")[0].color,
      size: darkColors.filter((k) => k.category === "category82b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category82b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "83b": {
    color: {
      background: darkColors.filter((k) => k.category === "category83b")[0].background,
      border: darkColors.filter((k) => k.category === "category83b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category83b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category83b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category83b")[0].color,
      size: darkColors.filter((k) => k.category === "category83b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category83b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "84b": {
    color: {
      background: darkColors.filter((k) => k.category === "category84b")[0].background,
      border: darkColors.filter((k) => k.category === "category84b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category84b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category84b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category84b")[0].color,
      size: darkColors.filter((k) => k.category === "category84b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category84b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "85b": {
    color: {
      background: darkColors.filter((k) => k.category === "category85b")[0].background,
      border: darkColors.filter((k) => k.category === "category85b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category85b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category85b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category85b")[0].color,
      size: darkColors.filter((k) => k.category === "category85b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category85b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "86b": {
    color: {
      background: darkColors.filter((k) => k.category === "category86b")[0].background,
      border: darkColors.filter((k) => k.category === "category86b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category86b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category86b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category86b")[0].color,
      size: darkColors.filter((k) => k.category === "category86b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category86b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "87b": {
    color: {
      background: darkColors.filter((k) => k.category === "category87b")[0].background,
      border: darkColors.filter((k) => k.category === "category87b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category87b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category87b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category87b")[0].color,
      size: darkColors.filter((k) => k.category === "category87b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category87b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "88b": {
    color: {
      background: darkColors.filter((k) => k.category === "category88b")[0].background,
      border: darkColors.filter((k) => k.category === "category88b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category88b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category88b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category88b")[0].color,
      size: darkColors.filter((k) => k.category === "category88b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category88b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },

  //dataOwnerUploaded
  "91b": {
    color: {
      background: darkColors.filter((k) => k.category === "category91b")[0].background,
      border: darkColors.filter((k) => k.category === "category91b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category91b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category91b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category91b")[0].color,
      size: darkColors.filter((k) => k.category === "category91b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category91b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "92b": {
    color: {
      background: darkColors.filter((k) => k.category === "category92b")[0].background,
      border: darkColors.filter((k) => k.category === "category92b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category92b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category92b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category92b")[0].color,
      size: darkColors.filter((k) => k.category === "category92b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category92b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "93b": {
    color: {
      background: darkColors.filter((k) => k.category === "category93b")[0].background,
      border: darkColors.filter((k) => k.category === "category93b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category93b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category93b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category93b")[0].color,
      size: darkColors.filter((k) => k.category === "category93b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category93b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "94b": {
    color: {
      background: darkColors.filter((k) => k.category === "category94b")[0].background,
      border: darkColors.filter((k) => k.category === "category94b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category94b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category94b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category94b")[0].color,
      size: darkColors.filter((k) => k.category === "category94b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category94b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "95b": {
    color: {
      background: darkColors.filter((k) => k.category === "category95b")[0].background,
      border: darkColors.filter((k) => k.category === "category95b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category95b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category95b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category95b")[0].color,
      size: darkColors.filter((k) => k.category === "category95b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category95b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "96b": {
    color: {
      background: darkColors.filter((k) => k.category === "category96b")[0].background,
      border: darkColors.filter((k) => k.category === "category96b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category96b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category96b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category96b")[0].color,
      size: darkColors.filter((k) => k.category === "category96b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category96b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "97b": {
    color: {
      background: darkColors.filter((k) => k.category === "category97b")[0].background,
      border: darkColors.filter((k) => k.category === "category97b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category97b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category97b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category97b")[0].color,
      size: darkColors.filter((k) => k.category === "category97b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category97b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "98b": {
    color: {
      background: darkColors.filter((k) => k.category === "category98b")[0].background,
      border: darkColors.filter((k) => k.category === "category98b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category98b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category98b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category98b")[0].color,
      size: darkColors.filter((k) => k.category === "category98b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category98b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  file: {
    shape: "circularImage",
  },

  "11adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category11a")[0].background,
      border: darkColors.filter((k) => k.category === "category11a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category11a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category11a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category11a")[0].color,
      size: darkColors.filter((k) => k.category === "category11a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category11a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "12adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category12a")[0].background,
      border: darkColors.filter((k) => k.category === "category12a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category12a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category12a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category12a")[0].color,
      size: darkColors.filter((k) => k.category === "category12a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category12a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "13adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category13a")[0].background,
      border: darkColors.filter((k) => k.category === "category13a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category13a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category13a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category13a")[0].color,
      size: darkColors.filter((k) => k.category === "category13a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category13a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "14adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category14a")[0].background,
      border: darkColors.filter((k) => k.category === "category14a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category14a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category14a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category14a")[0].color,
      size: darkColors.filter((k) => k.category === "category14a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category14a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "15adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category15a")[0].background,
      border: darkColors.filter((k) => k.category === "category15a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category15a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category15a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category15a")[0].color,
      size: darkColors.filter((k) => k.category === "category15a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category15a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "16adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category16a")[0].background,
      border: darkColors.filter((k) => k.category === "category16a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category16a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category16a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category16a")[0].color,
      size: darkColors.filter((k) => k.category === "category16a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category16a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "17adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category17a")[0].background,
      border: darkColors.filter((k) => k.category === "category17a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category17a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category17a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category17a")[0].color,
      size: darkColors.filter((k) => k.category === "category17a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category17a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "18adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category18a")[0].background,
      border: darkColors.filter((k) => k.category === "category18a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category18a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category18a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category18a")[0].color,
      size: darkColors.filter((k) => k.category === "category18a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category18a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },
  //21
  "21adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category21a")[0].background,
      border: darkColors.filter((k) => k.category === "category21a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category21a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category21a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category21a")[0].color,
      size: darkColors.filter((k) => k.category === "category21a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category21a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "22adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category22a")[0].background,
      border: darkColors.filter((k) => k.category === "category22a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category22a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category22a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category22a")[0].color,
      size: darkColors.filter((k) => k.category === "category22a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category22a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "23adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category23a")[0].background,
      border: darkColors.filter((k) => k.category === "category23a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category23a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category23a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category23a")[0].color,
      size: darkColors.filter((k) => k.category === "category23a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category23a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "24adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category24a")[0].background,
      border: darkColors.filter((k) => k.category === "category24a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category24a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category24a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category24a")[0].color,
      size: darkColors.filter((k) => k.category === "category24a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category24a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "25adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category25a")[0].background,
      border: darkColors.filter((k) => k.category === "category25a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category25a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category25a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category25a")[0].color,
      size: darkColors.filter((k) => k.category === "category25a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category25a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "26adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category26a")[0].background,
      border: darkColors.filter((k) => k.category === "category26a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category26a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category26a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category26a")[0].color,
      size: darkColors.filter((k) => k.category === "category26a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category26a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "27adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category27a")[0].background,
      border: darkColors.filter((k) => k.category === "category27a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category27a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category27a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category27a")[0].color,
      size: darkColors.filter((k) => k.category === "category27a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category27a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "28adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category28a")[0].background,
      border: darkColors.filter((k) => k.category === "category28a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category28a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category28a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category28a")[0].color,
      size: darkColors.filter((k) => k.category === "category28a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category28a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },
  //31
  "31adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category31a")[0].background,
      border: darkColors.filter((k) => k.category === "category31a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category31a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category31a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category31a")[0].color,
      size: darkColors.filter((k) => k.category === "category31a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category31a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "32adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category32a")[0].background,
      border: darkColors.filter((k) => k.category === "category32a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category32a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category32a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category32a")[0].color,
      size: darkColors.filter((k) => k.category === "category32a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category32a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "33adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category33a")[0].background,
      border: darkColors.filter((k) => k.category === "category33a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category33a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category33a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category33a")[0].color,
      size: darkColors.filter((k) => k.category === "category33a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category33a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "34adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category34a")[0].background,
      border: darkColors.filter((k) => k.category === "category34a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category34a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category34a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category34a")[0].color,
      size: darkColors.filter((k) => k.category === "category34a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category34a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "35adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category35a")[0].background,
      border: darkColors.filter((k) => k.category === "category35a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category35a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category35a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category35a")[0].color,
      size: darkColors.filter((k) => k.category === "category35a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category35a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "36adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category36a")[0].background,
      border: darkColors.filter((k) => k.category === "category36a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category36a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category36a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category36a")[0].color,
      size: darkColors.filter((k) => k.category === "category36a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category36a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "37adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category37a")[0].background,
      border: darkColors.filter((k) => k.category === "category37a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category37a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category37a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category37a")[0].color,
      size: darkColors.filter((k) => k.category === "category37a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category37a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "38adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category38a")[0].background,
      border: darkColors.filter((k) => k.category === "category38a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category38a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category38a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category38a")[0].color,
      size: darkColors.filter((k) => k.category === "category38a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category38a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },

  "41adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category41a")[0].background,
      border: darkColors.filter((k) => k.category === "category41a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category41a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category41a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category41a")[0].color,
      size: darkColors.filter((k) => k.category === "category41a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category41a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "42adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category42a")[0].background,
      border: darkColors.filter((k) => k.category === "category42a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category42a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category42a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category42a")[0].color,
      size: darkColors.filter((k) => k.category === "category42a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category42a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "43adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category43a")[0].background,
      border: darkColors.filter((k) => k.category === "category43a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category43a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category43a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category43a")[0].color,
      size: darkColors.filter((k) => k.category === "category43a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category43a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "44adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category44a")[0].background,
      border: darkColors.filter((k) => k.category === "category44a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category44a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category44a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category44a")[0].color,
      size: darkColors.filter((k) => k.category === "category44a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category44a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "45adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category45a")[0].background,
      border: darkColors.filter((k) => k.category === "category45a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category45a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category45a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category45a")[0].color,
      size: darkColors.filter((k) => k.category === "category45a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category45a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "46adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category46a")[0].background,
      border: darkColors.filter((k) => k.category === "category46a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category46a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category46a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category46a")[0].color,
      size: darkColors.filter((k) => k.category === "category46a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category46a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "47adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category47a")[0].background,
      border: darkColors.filter((k) => k.category === "category47a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category47a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category47a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category47a")[0].color,
      size: darkColors.filter((k) => k.category === "category47a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category47a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "48adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category48a")[0].background,
      border: darkColors.filter((k) => k.category === "category48a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category48a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category48a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category48a")[0].color,
      size: darkColors.filter((k) => k.category === "category48a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category48a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },
  //Health2

  "51adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category51a")[0].background,
      border: darkColors.filter((k) => k.category === "category51a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category51a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category51a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category51a")[0].color,
      size: darkColors.filter((k) => k.category === "category51a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category51a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "52adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category52a")[0].background,
      border: darkColors.filter((k) => k.category === "category52a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category52a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category52a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category52a")[0].color,
      size: darkColors.filter((k) => k.category === "category52a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category52a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "53adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category53a")[0].background,
      border: darkColors.filter((k) => k.category === "category53a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category53a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category53a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category53a")[0].color,
      size: darkColors.filter((k) => k.category === "category53a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category53a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "54adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category54a")[0].background,
      border: darkColors.filter((k) => k.category === "category54a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category54a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category54a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category54a")[0].color,
      size: darkColors.filter((k) => k.category === "category54a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category54a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "55adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category55a")[0].background,
      border: darkColors.filter((k) => k.category === "category55a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category55a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category55a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category55a")[0].color,
      size: darkColors.filter((k) => k.category === "category55a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category55a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "56adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category56a")[0].background,
      border: darkColors.filter((k) => k.category === "category56a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category56a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category56a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category56a")[0].color,
      size: darkColors.filter((k) => k.category === "category56a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category56a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "57adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category57a")[0].background,
      border: darkColors.filter((k) => k.category === "category57a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category57a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category57a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category57a")[0].color,
      size: darkColors.filter((k) => k.category === "category57a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category57a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "58adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category58a")[0].background,
      border: darkColors.filter((k) => k.category === "category58a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category58a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category58a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category58a")[0].color,
      size: darkColors.filter((k) => k.category === "category58a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category58a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },
  //Fitness
  "61adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category61a")[0].background,
      border: darkColors.filter((k) => k.category === "category61a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category61a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category61a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category61a")[0].color,
      size: darkColors.filter((k) => k.category === "category61a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category61a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "62adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category62a")[0].background,
      border: darkColors.filter((k) => k.category === "category62a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category62a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category62a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category62a")[0].color,
      size: darkColors.filter((k) => k.category === "category62a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category62a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "63adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category63a")[0].background,
      border: darkColors.filter((k) => k.category === "category63a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category63a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category63a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category63a")[0].color,
      size: darkColors.filter((k) => k.category === "category63a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category63a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "64adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category64a")[0].background,
      border: darkColors.filter((k) => k.category === "category64a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category64a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category64a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category64a")[0].color,
      size: darkColors.filter((k) => k.category === "category64a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category64a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "65adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category65a")[0].background,
      border: darkColors.filter((k) => k.category === "category65a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category65a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category65a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category65a")[0].color,
      size: darkColors.filter((k) => k.category === "category65a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category65a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "66adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category66a")[0].background,
      border: darkColors.filter((k) => k.category === "category66a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category66a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category66a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category66a")[0].color,
      size: darkColors.filter((k) => k.category === "category66a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category66a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "67adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category67a")[0].background,
      border: darkColors.filter((k) => k.category === "category67a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category67a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category67a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category67a")[0].color,
      size: darkColors.filter((k) => k.category === "category67a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category67a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "68adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category68a")[0].background,
      border: darkColors.filter((k) => k.category === "category68a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category68a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category68a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category68a")[0].color,
      size: darkColors.filter((k) => k.category === "category68a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category68a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },
  //Biometric
  "71adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category71a")[0].background,
      border: darkColors.filter((k) => k.category === "category71a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category71a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category71a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category71a")[0].color,
      size: darkColors.filter((k) => k.category === "category71a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category71a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "72adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category72a")[0].background,
      border: darkColors.filter((k) => k.category === "category72a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category72a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category72a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category72a")[0].color,
      size: darkColors.filter((k) => k.category === "category72a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category72a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "73adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category73a")[0].background,
      border: darkColors.filter((k) => k.category === "category73a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category73a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category73a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category73a")[0].color,
      size: darkColors.filter((k) => k.category === "category73a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category73a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "74adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category74a")[0].background,
      border: darkColors.filter((k) => k.category === "category74a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category74a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category74a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category74a")[0].color,
      size: darkColors.filter((k) => k.category === "category74a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category74a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "75adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category75a")[0].background,
      border: darkColors.filter((k) => k.category === "category75a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category75a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category75a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category75a")[0].color,
      size: darkColors.filter((k) => k.category === "category75a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category75a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "76adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category76a")[0].background,
      border: darkColors.filter((k) => k.category === "category76a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category76a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category76a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category76a")[0].color,
      size: darkColors.filter((k) => k.category === "category76a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category76a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "77adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category77a")[0].background,
      border: darkColors.filter((k) => k.category === "category77a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category77a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category77a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category77a")[0].color,
      size: darkColors.filter((k) => k.category === "category77a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category77a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "78adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category78a")[0].background,
      border: darkColors.filter((k) => k.category === "category78a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category78a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category78a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category78a")[0].color,
      size: darkColors.filter((k) => k.category === "category78a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category78a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },
  //Location
  "81adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category81a")[0].background,
      border: darkColors.filter((k) => k.category === "category81a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category81a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category81a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category81a")[0].color,
      size: darkColors.filter((k) => k.category === "category81a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category81a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "82adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category82a")[0].background,
      border: darkColors.filter((k) => k.category === "category82a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category82a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category82a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category82a")[0].color,
      size: darkColors.filter((k) => k.category === "category82a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category82a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "83adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category83a")[0].background,
      border: darkColors.filter((k) => k.category === "category83a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category83a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category83a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category83a")[0].color,
      size: darkColors.filter((k) => k.category === "category83a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category83a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "84adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category84a")[0].background,
      border: darkColors.filter((k) => k.category === "category84a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category84a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category84a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category84a")[0].color,
      size: darkColors.filter((k) => k.category === "category84a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category84a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "85adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category85a")[0].background,
      border: darkColors.filter((k) => k.category === "category85a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category85a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category85a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category85a")[0].color,
      size: darkColors.filter((k) => k.category === "category85a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category85a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "86adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category86a")[0].background,
      border: darkColors.filter((k) => k.category === "category86a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category86a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category86a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category86a")[0].color,
      size: darkColors.filter((k) => k.category === "category86a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category86a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "87adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category87a")[0].background,
      border: darkColors.filter((k) => k.category === "category87a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category87a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category87a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category87a")[0].color,
      size: darkColors.filter((k) => k.category === "category87a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category87a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "88adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category88a")[0].background,
      border: darkColors.filter((k) => k.category === "category88a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category88a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category88a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category88a")[0].color,
      size: darkColors.filter((k) => k.category === "category88a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category88a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },

  //dataOwnerUploaded
  "91adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category91a")[0].background,
      border: darkColors.filter((k) => k.category === "category91a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category91a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category91a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category91a")[0].color,
      size: darkColors.filter((k) => k.category === "category91a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category91a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "92adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category92a")[0].background,
      border: darkColors.filter((k) => k.category === "category92a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category92a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category92a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category92a")[0].color,
      size: darkColors.filter((k) => k.category === "category92a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category92a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "93adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category93a")[0].background,
      border: darkColors.filter((k) => k.category === "category93a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category93a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category93a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category93a")[0].color,
      size: darkColors.filter((k) => k.category === "category93a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category93a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "94adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category94a")[0].background,
      border: darkColors.filter((k) => k.category === "category94a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category94a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category94a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category94a")[0].color,
      size: darkColors.filter((k) => k.category === "category94a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category94a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "95adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category95a")[0].background,
      border: darkColors.filter((k) => k.category === "category95a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category95a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category95a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category95a")[0].color,
      size: darkColors.filter((k) => k.category === "category95a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category95a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "96adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category96a")[0].background,
      border: darkColors.filter((k) => k.category === "category96a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category96a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category96a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category96a")[0].color,
      size: darkColors.filter((k) => k.category === "category96a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category96a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "97adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category97a")[0].background,
      border: darkColors.filter((k) => k.category === "category97a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category97a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category97a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category97a")[0].color,
      size: darkColors.filter((k) => k.category === "category97a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category97a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "98adiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category98a")[0].background,
      border: darkColors.filter((k) => k.category === "category98a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category98a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category98a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category98a")[0].color,
      size: darkColors.filter((k) => k.category === "category98a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category98a")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },

  //11
  "11bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category11b")[0].background,
      border: darkColors.filter((k) => k.category === "category11b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category11b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category11b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category11b")[0].color,
      size: darkColors.filter((k) => k.category === "category11b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category11b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "12bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category12b")[0].background,
      border: darkColors.filter((k) => k.category === "category12b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category12b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category12b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category12b")[0].color,
      size: darkColors.filter((k) => k.category === "category12b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category12b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "13bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category13b")[0].background,
      border: darkColors.filter((k) => k.category === "category13b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category13b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category13b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category13b")[0].color,
      size: darkColors.filter((k) => k.category === "category13b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category13b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "14bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category14b")[0].background,
      border: darkColors.filter((k) => k.category === "category14b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category14b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category14b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category14b")[0].color,
      size: darkColors.filter((k) => k.category === "category14b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category14b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "15bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category15b")[0].background,
      border: darkColors.filter((k) => k.category === "category15b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category15b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category15b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category15b")[0].color,
      size: darkColors.filter((k) => k.category === "category15b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category15b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "16bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category16b")[0].background,
      border: darkColors.filter((k) => k.category === "category16b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category16b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category16b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category16b")[0].color,
      size: darkColors.filter((k) => k.category === "category16b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category16b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "17bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category17b")[0].background,
      border: darkColors.filter((k) => k.category === "category17b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category17b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category17b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category17b")[0].color,
      size: darkColors.filter((k) => k.category === "category17b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category17b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "18bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category18b")[0].background,
      border: darkColors.filter((k) => k.category === "category18b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category18b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category18b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category18b")[0].color,
      size: darkColors.filter((k) => k.category === "category18b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category18b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },
  //21
  "21bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category21b")[0].background,
      border: darkColors.filter((k) => k.category === "category21b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category21b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category21b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category21b")[0].color,
      size: darkColors.filter((k) => k.category === "category21b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category21b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "22bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category22b")[0].background,
      border: darkColors.filter((k) => k.category === "category22b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category22b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category22b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category22b")[0].color,
      size: darkColors.filter((k) => k.category === "category22b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category22b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "23bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category23b")[0].background,
      border: darkColors.filter((k) => k.category === "category23b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category23b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category23b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category23b")[0].color,
      size: darkColors.filter((k) => k.category === "category23b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category23b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "24bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category24b")[0].background,
      border: darkColors.filter((k) => k.category === "category24b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category24b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category24b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category24b")[0].color,
      size: darkColors.filter((k) => k.category === "category24b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category24b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "25bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category25b")[0].background,
      border: darkColors.filter((k) => k.category === "category25b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category25b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category25b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category25b")[0].color,
      size: darkColors.filter((k) => k.category === "category25b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category25b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "26bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category26b")[0].background,
      border: darkColors.filter((k) => k.category === "category26b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category26b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category26b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category26b")[0].color,
      size: darkColors.filter((k) => k.category === "category26b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category26b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "27bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category27b")[0].background,
      border: darkColors.filter((k) => k.category === "category27b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category27b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category27b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category27b")[0].color,
      size: darkColors.filter((k) => k.category === "category27b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category27b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "28bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category28b")[0].background,
      border: darkColors.filter((k) => k.category === "category28b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category28b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category28b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category28b")[0].color,
      size: darkColors.filter((k) => k.category === "category28b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category28b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },
  //31
  "31bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category31b")[0].background,
      border: darkColors.filter((k) => k.category === "category31b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category31b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category31b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category31b")[0].color,
      size: darkColors.filter((k) => k.category === "category31b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category31b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "32bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category32b")[0].background,
      border: darkColors.filter((k) => k.category === "category32b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category32b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category32b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category32b")[0].color,
      size: darkColors.filter((k) => k.category === "category32b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category32b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "33bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category33b")[0].background,
      border: darkColors.filter((k) => k.category === "category33b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category33b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category33b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category33b")[0].color,
      size: darkColors.filter((k) => k.category === "category33b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category33b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "34bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category34b")[0].background,
      border: darkColors.filter((k) => k.category === "category34b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category34b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category34b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category34b")[0].color,
      size: darkColors.filter((k) => k.category === "category34b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category34b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "35bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category35b")[0].background,
      border: darkColors.filter((k) => k.category === "category35b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category35b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category35b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category35b")[0].color,
      size: darkColors.filter((k) => k.category === "category35b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category35b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "36bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category36b")[0].background,
      border: darkColors.filter((k) => k.category === "category36b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category36b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category36b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category36b")[0].color,
      size: darkColors.filter((k) => k.category === "category36b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category36b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "37bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category37b")[0].background,
      border: darkColors.filter((k) => k.category === "category37b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category37b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category37b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category37b")[0].color,
      size: darkColors.filter((k) => k.category === "category37b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category37b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "38bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category38b")[0].background,
      border: darkColors.filter((k) => k.category === "category38b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category38b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category38b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category38b")[0].color,
      size: darkColors.filter((k) => k.category === "category38b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category38b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },

  "41bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category41b")[0].background,
      border: darkColors.filter((k) => k.category === "category41b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category41b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category41b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category41b")[0].color,
      size: darkColors.filter((k) => k.category === "category41b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category41b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "42bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category42b")[0].background,
      border: darkColors.filter((k) => k.category === "category42b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category42b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category42b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category42b")[0].color,
      size: darkColors.filter((k) => k.category === "category42b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category42b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "43bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category43b")[0].background,
      border: darkColors.filter((k) => k.category === "category43b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category43b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category43b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category43b")[0].color,
      size: darkColors.filter((k) => k.category === "category43b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category43b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "44bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category44b")[0].background,
      border: darkColors.filter((k) => k.category === "category44b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category44b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category44b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category44b")[0].color,
      size: darkColors.filter((k) => k.category === "category44b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category44b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "45bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category45b")[0].background,
      border: darkColors.filter((k) => k.category === "category45b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category45b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category45b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category45b")[0].color,
      size: darkColors.filter((k) => k.category === "category45b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category45b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "46bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category46b")[0].background,
      border: darkColors.filter((k) => k.category === "category46b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category46b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category46b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category46b")[0].color,
      size: darkColors.filter((k) => k.category === "category46b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category46b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "47bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category47b")[0].background,
      border: darkColors.filter((k) => k.category === "category47b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category47b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category47b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category47b")[0].color,
      size: darkColors.filter((k) => k.category === "category47b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category47b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "48bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category48b")[0].background,
      border: darkColors.filter((k) => k.category === "category48b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category48b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category48b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category48b")[0].color,
      size: darkColors.filter((k) => k.category === "category48b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category48b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },
  //Health2

  "51bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category51b")[0].background,
      border: darkColors.filter((k) => k.category === "category51b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category51b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category51b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category51b")[0].color,
      size: darkColors.filter((k) => k.category === "category51b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category51b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "52bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category52b")[0].background,
      border: darkColors.filter((k) => k.category === "category52b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category52b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category52b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category52b")[0].color,
      size: darkColors.filter((k) => k.category === "category52b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category52b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "53bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category53b")[0].background,
      border: darkColors.filter((k) => k.category === "category53b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category53b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category53b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category53b")[0].color,
      size: darkColors.filter((k) => k.category === "category53b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category53b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "54bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category54b")[0].background,
      border: darkColors.filter((k) => k.category === "category54b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category54b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category54b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category54b")[0].color,
      size: darkColors.filter((k) => k.category === "category54b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category54b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "55bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category55b")[0].background,
      border: darkColors.filter((k) => k.category === "category55b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category55b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category55b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category55b")[0].color,
      size: darkColors.filter((k) => k.category === "category55b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category55b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "56bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category56b")[0].background,
      border: darkColors.filter((k) => k.category === "category56b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category56b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category56b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category56b")[0].color,
      size: darkColors.filter((k) => k.category === "category56b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category56b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "57bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category57b")[0].background,
      border: darkColors.filter((k) => k.category === "category57b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category57b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category57b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category57b")[0].color,
      size: darkColors.filter((k) => k.category === "category57b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category57b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "58bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category58b")[0].background,
      border: darkColors.filter((k) => k.category === "category58b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category58b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category58b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category58b")[0].color,
      size: darkColors.filter((k) => k.category === "category58b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category58b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },
  //Fitness
  "61bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category61b")[0].background,
      border: darkColors.filter((k) => k.category === "category61b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category61b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category61b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category61b")[0].color,
      size: darkColors.filter((k) => k.category === "category61b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category61b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "62bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category62b")[0].background,
      border: darkColors.filter((k) => k.category === "category62b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category62b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category62b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category62b")[0].color,
      size: darkColors.filter((k) => k.category === "category62b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category62b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "63bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category63b")[0].background,
      border: darkColors.filter((k) => k.category === "category63b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category63b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category63b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category63b")[0].color,
      size: darkColors.filter((k) => k.category === "category63b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category63b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "64bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category64b")[0].background,
      border: darkColors.filter((k) => k.category === "category64b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category64b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category64b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category64b")[0].color,
      size: darkColors.filter((k) => k.category === "category64b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category64b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "65bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category65b")[0].background,
      border: darkColors.filter((k) => k.category === "category65b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category65b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category65b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category65b")[0].color,
      size: darkColors.filter((k) => k.category === "category65b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category65b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "66bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category66b")[0].background,
      border: darkColors.filter((k) => k.category === "category66b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category66b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category66b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category66b")[0].color,
      size: darkColors.filter((k) => k.category === "category66b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category66b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "67bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category67b")[0].background,
      border: darkColors.filter((k) => k.category === "category67b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category67b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category67b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category67b")[0].color,
      size: darkColors.filter((k) => k.category === "category67b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category67b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "68bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category68b")[0].background,
      border: darkColors.filter((k) => k.category === "category68b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category68b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category68b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category68b")[0].color,
      size: darkColors.filter((k) => k.category === "category68b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category68b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },
  //Biometric
  "71bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category71b")[0].background,
      border: darkColors.filter((k) => k.category === "category71b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category71b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category71b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category71b")[0].color,
      size: darkColors.filter((k) => k.category === "category71b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category71b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "72bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category72b")[0].background,
      border: darkColors.filter((k) => k.category === "category72b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category72b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category72b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category72b")[0].color,
      size: darkColors.filter((k) => k.category === "category72b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category72b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "73bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category73b")[0].background,
      border: darkColors.filter((k) => k.category === "category73b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category73b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category73b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category73b")[0].color,
      size: darkColors.filter((k) => k.category === "category73b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category73b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "74bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category74b")[0].background,
      border: darkColors.filter((k) => k.category === "category74b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category74b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category74b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category74b")[0].color,
      size: darkColors.filter((k) => k.category === "category74b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category74b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "75bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category75b")[0].background,
      border: darkColors.filter((k) => k.category === "category75b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category75b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category75b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category75b")[0].color,
      size: darkColors.filter((k) => k.category === "category75b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category75b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "76bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category76b")[0].background,
      border: darkColors.filter((k) => k.category === "category76b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category76b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category76b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category76b")[0].color,
      size: darkColors.filter((k) => k.category === "category76b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category76b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "77bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category77b")[0].background,
      border: darkColors.filter((k) => k.category === "category77b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category77b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category77b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category77b")[0].color,
      size: darkColors.filter((k) => k.category === "category77b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category77b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "78bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category78b")[0].background,
      border: darkColors.filter((k) => k.category === "category78b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category78b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category78b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category78b")[0].color,
      size: darkColors.filter((k) => k.category === "category78b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category78b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },
  //Location
  "81bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category81b")[0].background,
      border: darkColors.filter((k) => k.category === "category81b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category81b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category81b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category81b")[0].color,
      size: darkColors.filter((k) => k.category === "category81b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category81b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "82bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category82b")[0].background,
      border: darkColors.filter((k) => k.category === "category82b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category82b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category82b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category82b")[0].color,
      size: darkColors.filter((k) => k.category === "category82b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category82b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "83bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category83b")[0].background,
      border: darkColors.filter((k) => k.category === "category83b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category83b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category83b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category83b")[0].color,
      size: darkColors.filter((k) => k.category === "category83b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category83b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "84bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category84b")[0].background,
      border: darkColors.filter((k) => k.category === "category84b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category84b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category84b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category84b")[0].color,
      size: darkColors.filter((k) => k.category === "category84b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category84b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "85bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category85b")[0].background,
      border: darkColors.filter((k) => k.category === "category85b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category85b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category85b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category85b")[0].color,
      size: darkColors.filter((k) => k.category === "category85b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category85b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "86bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category86b")[0].background,
      border: darkColors.filter((k) => k.category === "category86b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category86b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category86b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category86b")[0].color,
      size: darkColors.filter((k) => k.category === "category86b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category86b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "87bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category87b")[0].background,
      border: darkColors.filter((k) => k.category === "category87b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category87b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category87b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category87b")[0].color,
      size: darkColors.filter((k) => k.category === "category87b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category87b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "88bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category88b")[0].background,
      border: darkColors.filter((k) => k.category === "category88b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category88b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category88b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category88b")[0].color,
      size: darkColors.filter((k) => k.category === "category88b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category88b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },

  //dataOwnerUploaded
  "91bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category91b")[0].background,
      border: darkColors.filter((k) => k.category === "category91b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category91b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category91b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category91b")[0].color,
      size: darkColors.filter((k) => k.category === "category91b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category91b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 10,
  },
  "92bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category92b")[0].background,
      border: darkColors.filter((k) => k.category === "category92b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category92b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category92b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category92b")[0].color,
      size: darkColors.filter((k) => k.category === "category92b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category92b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 9,
  },
  "93bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category93b")[0].background,
      border: darkColors.filter((k) => k.category === "category93b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category93b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category93b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category93b")[0].color,
      size: darkColors.filter((k) => k.category === "category93b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category93b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 8,
  },
  "94bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category94b")[0].background,
      border: darkColors.filter((k) => k.category === "category94b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category94b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category94b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category94b")[0].color,
      size: darkColors.filter((k) => k.category === "category94b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category94b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 7,
  },
  "95bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category95b")[0].background,
      border: darkColors.filter((k) => k.category === "category95b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category95b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category95b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category95b")[0].color,
      size: darkColors.filter((k) => k.category === "category95b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category95b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "96bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category96b")[0].background,
      border: darkColors.filter((k) => k.category === "category96b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category96b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category96b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category96b")[0].color,
      size: darkColors.filter((k) => k.category === "category96b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category96b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 5,
  },
  "97bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category97b")[0].background,
      border: darkColors.filter((k) => k.category === "category97b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category97b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category97b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category97b")[0].color,
      size: darkColors.filter((k) => k.category === "category97b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category97b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 4,
  },
  "98bdiamond": {
    color: {
      background: darkColors.filter((k) => k.category === "category98b")[0].background,
      border: darkColors.filter((k) => k.category === "category98b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category98b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category98b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: darkColors.filter((k) => k.category === "category98b")[0].color,
      size: darkColors.filter((k) => k.category === "category98b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category98b")[0].bubbleSize,
    shape: "diamond",
    margin: 2,
    mass: 3,
  },

  "11agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category11a")[0].background,
      border: darkColors.filter((k) => k.category === "category11a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category11a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category11a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category11a")[0].color,
      size: darkColors.filter((k) => k.category === "category11a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category11a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "12agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category12a")[0].background,
      border: darkColors.filter((k) => k.category === "category12a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category12a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category12a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category12a")[0].color,
      size: darkColors.filter((k) => k.category === "category12a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category12a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "13agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category13a")[0].background,
      border: darkColors.filter((k) => k.category === "category13a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category13a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category13a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category13a")[0].color,
      size: darkColors.filter((k) => k.category === "category13a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category13a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "14agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category14a")[0].background,
      border: darkColors.filter((k) => k.category === "category14a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category14a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category14a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category14a")[0].color,
      size: darkColors.filter((k) => k.category === "category14a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category14a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "15agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category15a")[0].background,
      border: darkColors.filter((k) => k.category === "category15a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category15a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category15a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category15a")[0].color,
      size: darkColors.filter((k) => k.category === "category15a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category15a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "16agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category16a")[0].background,
      border: darkColors.filter((k) => k.category === "category16a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category16a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category16a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category16a")[0].color,
      size: darkColors.filter((k) => k.category === "category16a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category16a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "17agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category17a")[0].background,
      border: darkColors.filter((k) => k.category === "category17a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category17a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category17a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category17a")[0].color,
      size: darkColors.filter((k) => k.category === "category17a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category17a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "18agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category18a")[0].background,
      border: darkColors.filter((k) => k.category === "category18a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category18a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category18a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category18a")[0].color,
      size: darkColors.filter((k) => k.category === "category18a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category18a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //21
  "21agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category21a")[0].background,
      border: darkColors.filter((k) => k.category === "category21a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category21a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category21a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category21a")[0].color,
      size: darkColors.filter((k) => k.category === "category21a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category21a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "22agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category22a")[0].background,
      border: darkColors.filter((k) => k.category === "category22a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category22a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category22a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category22a")[0].color,
      size: darkColors.filter((k) => k.category === "category22a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category22a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "23agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category23a")[0].background,
      border: darkColors.filter((k) => k.category === "category23a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category23a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category23a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category23a")[0].color,
      size: darkColors.filter((k) => k.category === "category23a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category23a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "24agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category24a")[0].background,
      border: darkColors.filter((k) => k.category === "category24a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category23a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category23a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category24a")[0].color,
      size: darkColors.filter((k) => k.category === "category24a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category24a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "25agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category25a")[0].background,
      border: darkColors.filter((k) => k.category === "category25a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category25a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category25a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category25a")[0].color,
      size: darkColors.filter((k) => k.category === "category25a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category25a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "26agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category26a")[0].background,
      border: darkColors.filter((k) => k.category === "category26a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category26a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category26a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category26a")[0].color,
      size: darkColors.filter((k) => k.category === "category26a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category26a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "27agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category27a")[0].background,
      border: darkColors.filter((k) => k.category === "category27a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category27a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category27a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category27a")[0].color,
      size: darkColors.filter((k) => k.category === "category27a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category27a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "28agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category28a")[0].background,
      border: darkColors.filter((k) => k.category === "category28a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category28a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category28a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category28a")[0].color,
      size: darkColors.filter((k) => k.category === "category28a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category28a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //31
  "31agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category31a")[0].background,
      border: darkColors.filter((k) => k.category === "category31a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category31a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category31a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category31a")[0].color,
      size: darkColors.filter((k) => k.category === "category31a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category31a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "32agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category32a")[0].background,
      border: darkColors.filter((k) => k.category === "category32a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category32a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category32a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category32a")[0].color,
      size: darkColors.filter((k) => k.category === "category32a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category32a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "33agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category33a")[0].background,
      border: darkColors.filter((k) => k.category === "category33a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category33a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category33a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category33a")[0].color,
      size: darkColors.filter((k) => k.category === "category33a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category33a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "34agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category34a")[0].background,
      border: darkColors.filter((k) => k.category === "category34a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category34a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category34a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category34a")[0].color,
      size: darkColors.filter((k) => k.category === "category34a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category34a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "35agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category35a")[0].background,
      border: darkColors.filter((k) => k.category === "category35a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category35a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category35a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category35a")[0].color,
      size: darkColors.filter((k) => k.category === "category35a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category35a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "36agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category36a")[0].background,
      border: darkColors.filter((k) => k.category === "category36a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category36a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category36a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category36a")[0].color,
      size: darkColors.filter((k) => k.category === "category36a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category36a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "37agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category37a")[0].background,
      border: darkColors.filter((k) => k.category === "category37a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category37a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category37a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category37a")[0].color,
      size: darkColors.filter((k) => k.category === "category37a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category37a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "38agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category38a")[0].background,
      border: darkColors.filter((k) => k.category === "category38a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category38a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category38a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category38a")[0].color,
      size: darkColors.filter((k) => k.category === "category38a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category38a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },

  "41agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category41a")[0].background,
      border: darkColors.filter((k) => k.category === "category41a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category41a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category41a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category41a")[0].color,
      size: darkColors.filter((k) => k.category === "category41a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category41a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "42agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category42a")[0].background,
      border: darkColors.filter((k) => k.category === "category42a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category42a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category42a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category42a")[0].color,
      size: darkColors.filter((k) => k.category === "category42a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category42a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "43agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category43a")[0].background,
      border: darkColors.filter((k) => k.category === "category43a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category43a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category43a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category43a")[0].color,
      size: darkColors.filter((k) => k.category === "category43a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category43a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "44agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category44a")[0].background,
      border: darkColors.filter((k) => k.category === "category44a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category44a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category44a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category44a")[0].color,
      size: darkColors.filter((k) => k.category === "category44a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category44a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "45agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category45a")[0].background,
      border: darkColors.filter((k) => k.category === "category45a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category45a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category45a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category45a")[0].color,
      size: darkColors.filter((k) => k.category === "category45a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category45a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "46agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category46a")[0].background,
      border: darkColors.filter((k) => k.category === "category46a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category46a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category46a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category46a")[0].color,
      size: darkColors.filter((k) => k.category === "category46a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category46a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "47agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category47a")[0].background,
      border: darkColors.filter((k) => k.category === "category47a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category47a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category47a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category47a")[0].color,
      size: darkColors.filter((k) => k.category === "category47a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category47a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "48agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category48a")[0].background,
      border: darkColors.filter((k) => k.category === "category48a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category48a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category48a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category48a")[0].color,
      size: darkColors.filter((k) => k.category === "category48a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category48a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //Health2

  "51agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category51a")[0].background,
      border: darkColors.filter((k) => k.category === "category51a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category51a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category51a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category51a")[0].color,
      size: darkColors.filter((k) => k.category === "category51a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category51a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "52agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category52a")[0].background,
      border: darkColors.filter((k) => k.category === "category52a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category52a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category52a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category52a")[0].color,
      size: darkColors.filter((k) => k.category === "category52a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category52a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "53agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category53a")[0].background,
      border: darkColors.filter((k) => k.category === "category53a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category53a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category53a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category53a")[0].color,
      size: darkColors.filter((k) => k.category === "category53a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category53a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "54agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category54a")[0].background,
      border: darkColors.filter((k) => k.category === "category54a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category54a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category54a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category54a")[0].color,
      size: darkColors.filter((k) => k.category === "category54a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category54a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "55agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category55a")[0].background,
      border: darkColors.filter((k) => k.category === "category55a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category55a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category55a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category55a")[0].color,
      size: darkColors.filter((k) => k.category === "category55a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category55a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "56agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category56a")[0].background,
      border: darkColors.filter((k) => k.category === "category56a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category56a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category56a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category56a")[0].color,
      size: darkColors.filter((k) => k.category === "category56a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category56a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "57agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category57a")[0].background,
      border: darkColors.filter((k) => k.category === "category57a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category57a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category57a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category57a")[0].color,
      size: darkColors.filter((k) => k.category === "category57a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category57a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "58agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category58a")[0].background,
      border: darkColors.filter((k) => k.category === "category58a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category58a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category58a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category58a")[0].color,
      size: darkColors.filter((k) => k.category === "category58a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category58a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //Fitness
  "61agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category61a")[0].background,
      border: darkColors.filter((k) => k.category === "category61a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category61a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category61a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category61a")[0].color,
      size: darkColors.filter((k) => k.category === "category61a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category61a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "62agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category62a")[0].background,
      border: darkColors.filter((k) => k.category === "category62a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category62a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category62a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category62a")[0].color,
      size: darkColors.filter((k) => k.category === "category62a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category62a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "63agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category63a")[0].background,
      border: darkColors.filter((k) => k.category === "category63a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category63a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category63a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category63a")[0].color,
      size: darkColors.filter((k) => k.category === "category63a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category63a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "64agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category64a")[0].background,
      border: darkColors.filter((k) => k.category === "category64a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category64a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category64a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category64a")[0].color,
      size: darkColors.filter((k) => k.category === "category64a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category64a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "65agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category65a")[0].background,
      border: darkColors.filter((k) => k.category === "category65a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category65a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category65a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category65a")[0].color,
      size: darkColors.filter((k) => k.category === "category65a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category65a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "66agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category66a")[0].background,
      border: darkColors.filter((k) => k.category === "category66a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category66a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category66a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category66a")[0].color,
      size: darkColors.filter((k) => k.category === "category66a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category66a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "67agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category67a")[0].background,
      border: darkColors.filter((k) => k.category === "category67a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category67a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category67a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category67a")[0].color,
      size: darkColors.filter((k) => k.category === "category67a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category67a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "68agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category68a")[0].background,
      border: darkColors.filter((k) => k.category === "category68a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category68a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category68a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category68a")[0].color,
      size: darkColors.filter((k) => k.category === "category68a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category68a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //Biometric
  "71agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category71a")[0].background,
      border: darkColors.filter((k) => k.category === "category71a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category71a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category71a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category71a")[0].color,
      size: darkColors.filter((k) => k.category === "category71a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category71a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "72agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category72a")[0].background,
      border: darkColors.filter((k) => k.category === "category72a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category72a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category72a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category72a")[0].color,
      size: darkColors.filter((k) => k.category === "category72a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category72a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "73agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category73a")[0].background,
      border: darkColors.filter((k) => k.category === "category73a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category73a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category73a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category73a")[0].color,
      size: darkColors.filter((k) => k.category === "category73a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category73a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "74agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category74a")[0].background,
      border: darkColors.filter((k) => k.category === "category74a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category74a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category74a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category74a")[0].color,
      size: darkColors.filter((k) => k.category === "category74a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category74a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "75agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category75a")[0].background,
      border: darkColors.filter((k) => k.category === "category75a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category75a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category75a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category75a")[0].color,
      size: darkColors.filter((k) => k.category === "category75a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category75a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "76agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category76a")[0].background,
      border: darkColors.filter((k) => k.category === "category76a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category76a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category76a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category76a")[0].color,
      size: darkColors.filter((k) => k.category === "category76a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category76a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "77agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category77a")[0].background,
      border: darkColors.filter((k) => k.category === "category77a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category77a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category77a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category77a")[0].color,
      size: darkColors.filter((k) => k.category === "category77a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category77a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "78agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category78a")[0].background,
      border: darkColors.filter((k) => k.category === "category78a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category78a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category78a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category78a")[0].color,
      size: darkColors.filter((k) => k.category === "category78a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category78a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //Location
  "81agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category81a")[0].background,
      border: darkColors.filter((k) => k.category === "category81a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category81a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category81a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category81a")[0].color,
      size: darkColors.filter((k) => k.category === "category81a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category81a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "82agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category82a")[0].background,
      border: darkColors.filter((k) => k.category === "category82a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category82a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category82a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category82a")[0].color,
      size: darkColors.filter((k) => k.category === "category82a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category82a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "83agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category83a")[0].background,
      border: darkColors.filter((k) => k.category === "category83a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category83a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category83a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category83a")[0].color,
      size: darkColors.filter((k) => k.category === "category83a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category83a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "84agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category84a")[0].background,
      border: darkColors.filter((k) => k.category === "category84a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category84a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category84a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category84a")[0].color,
      size: darkColors.filter((k) => k.category === "category84a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category84a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "85agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category85a")[0].background,
      border: darkColors.filter((k) => k.category === "category85a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category85a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category85a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category85a")[0].color,
      size: darkColors.filter((k) => k.category === "category85a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category85a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "86agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category86a")[0].background,
      border: darkColors.filter((k) => k.category === "category86a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category86a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category86a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category86a")[0].color,
      size: darkColors.filter((k) => k.category === "category86a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category86a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "87agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category87a")[0].background,
      border: darkColors.filter((k) => k.category === "category87a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category87a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category87a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category87a")[0].color,
      size: darkColors.filter((k) => k.category === "category87a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category87a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "88agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category88a")[0].background,
      border: darkColors.filter((k) => k.category === "category88a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category88a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category88a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category88a")[0].color,
      size: darkColors.filter((k) => k.category === "category88a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category88a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },

  //dataOwnerUploaded
  "91agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category91a")[0].background,
      border: darkColors.filter((k) => k.category === "category91a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category91a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category91a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category91a")[0].color,
      size: darkColors.filter((k) => k.category === "category91a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category91a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "92agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category92a")[0].background,
      border: darkColors.filter((k) => k.category === "category92a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category92a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category92a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category92a")[0].color,
      size: darkColors.filter((k) => k.category === "category92a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category92a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "93agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category93a")[0].background,
      border: darkColors.filter((k) => k.category === "category93a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category93a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category93a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category93a")[0].color,
      size: darkColors.filter((k) => k.category === "category93a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category93a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "94agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category94a")[0].background,
      border: darkColors.filter((k) => k.category === "category94a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category94a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category94a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category94a")[0].color,
      size: darkColors.filter((k) => k.category === "category94a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category94a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "95agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category95a")[0].background,
      border: darkColors.filter((k) => k.category === "category95a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category95a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category95a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category95a")[0].color,
      size: darkColors.filter((k) => k.category === "category95a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category95a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "96agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category96a")[0].background,
      border: darkColors.filter((k) => k.category === "category96a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category96a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category96a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category96a")[0].color,
      size: darkColors.filter((k) => k.category === "category96a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category96a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "97agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category97a")[0].background,
      border: darkColors.filter((k) => k.category === "category97a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category97a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category97a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category97a")[0].color,
      size: darkColors.filter((k) => k.category === "category97a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category97a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "98agroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category98a")[0].background,
      border: darkColors.filter((k) => k.category === "category98a")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category98a")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category98a")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category98a")[0].color,
      size: darkColors.filter((k) => k.category === "category98a")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category98a")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },

  //11
  "11bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category11b")[0].background,
      border: darkColors.filter((k) => k.category === "category11b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category11b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category11b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category11b")[0].color,
      size: darkColors.filter((k) => k.category === "category11b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category11b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "12bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category12b")[0].background,
      border: darkColors.filter((k) => k.category === "category12b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category12b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category12b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category12b")[0].color,
      size: darkColors.filter((k) => k.category === "category12b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category12b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "13bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category13b")[0].background,
      border: darkColors.filter((k) => k.category === "category13b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category13b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category13b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category13b")[0].color,
      size: darkColors.filter((k) => k.category === "category13b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category13b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "14bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category14b")[0].background,
      border: darkColors.filter((k) => k.category === "category14b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category14b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category14b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category14b")[0].color,
      size: darkColors.filter((k) => k.category === "category14b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category14b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "15bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category15b")[0].background,
      border: darkColors.filter((k) => k.category === "category15b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category15b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category15b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category15b")[0].color,
      size: darkColors.filter((k) => k.category === "category15b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category15b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "16bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category16b")[0].background,
      border: darkColors.filter((k) => k.category === "category16b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category16b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category16b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category16b")[0].color,
      size: darkColors.filter((k) => k.category === "category16b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category16b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "17bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category17b")[0].background,
      border: darkColors.filter((k) => k.category === "category17b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category17b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category17b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category17b")[0].color,
      size: darkColors.filter((k) => k.category === "category17b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category17b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "18bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category18b")[0].background,
      border: darkColors.filter((k) => k.category === "category18b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category18b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category18b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category18b")[0].color,
      size: darkColors.filter((k) => k.category === "category18b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category18b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //21
  "21bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category21b")[0].background,
      border: darkColors.filter((k) => k.category === "category21b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category21b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category21b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category21b")[0].color,
      size: darkColors.filter((k) => k.category === "category21b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category21b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "22bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category22b")[0].background,
      border: darkColors.filter((k) => k.category === "category22b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category22b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category22b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category22b")[0].color,
      size: darkColors.filter((k) => k.category === "category22b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category22b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "23bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category23b")[0].background,
      border: darkColors.filter((k) => k.category === "category23b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category23b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category23b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category23b")[0].color,
      size: darkColors.filter((k) => k.category === "category23b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category23b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "24bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category24b")[0].background,
      border: darkColors.filter((k) => k.category === "category24b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category24b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category24b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category24b")[0].color,
      size: darkColors.filter((k) => k.category === "category24b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category24b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "25bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category25b")[0].background,
      border: darkColors.filter((k) => k.category === "category25b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category25b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category25b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category25b")[0].color,
      size: darkColors.filter((k) => k.category === "category25b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category25b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "26bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category26b")[0].background,
      border: darkColors.filter((k) => k.category === "category26b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category26b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category26b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category26b")[0].color,
      size: darkColors.filter((k) => k.category === "category26b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category26b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "27bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category27b")[0].background,
      border: darkColors.filter((k) => k.category === "category27b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category27b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category27b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category27b")[0].color,
      size: darkColors.filter((k) => k.category === "category27b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category27b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "28bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category28b")[0].background,
      border: darkColors.filter((k) => k.category === "category28b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category28b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category28b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category28b")[0].color,
      size: darkColors.filter((k) => k.category === "category28b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category28b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //31
  "31bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category31b")[0].background,
      border: darkColors.filter((k) => k.category === "category31b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category31b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category31b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category31b")[0].color,
      size: darkColors.filter((k) => k.category === "category31b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category31b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "32bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category32b")[0].background,
      border: darkColors.filter((k) => k.category === "category32b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category32b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category32b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category32b")[0].color,
      size: darkColors.filter((k) => k.category === "category32b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category32b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "33bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category33b")[0].background,
      border: darkColors.filter((k) => k.category === "category33b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category33b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category33b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category33b")[0].color,
      size: darkColors.filter((k) => k.category === "category33b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category33b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "34bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category34b")[0].background,
      border: darkColors.filter((k) => k.category === "category34b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category34b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category34b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category34b")[0].color,
      size: darkColors.filter((k) => k.category === "category34b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category34b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "35bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category35b")[0].background,
      border: darkColors.filter((k) => k.category === "category35b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category35b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category35b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category35b")[0].color,
      size: darkColors.filter((k) => k.category === "category35b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category35b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "36bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category36b")[0].background,
      border: darkColors.filter((k) => k.category === "category36b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category36b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category36b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category36b")[0].color,
      size: darkColors.filter((k) => k.category === "category36b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category36b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "37bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category37b")[0].background,
      border: darkColors.filter((k) => k.category === "category37b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category37b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category37b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category37b")[0].color,
      size: darkColors.filter((k) => k.category === "category37b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category37b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "38bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category38b")[0].background,
      border: darkColors.filter((k) => k.category === "category38b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category38b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category38b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category38b")[0].color,
      size: darkColors.filter((k) => k.category === "category38b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category38b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },

  "41bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category41b")[0].background,
      border: darkColors.filter((k) => k.category === "category41b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category41b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category41b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category41b")[0].color,
      size: darkColors.filter((k) => k.category === "category41b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category41b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "42bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category42b")[0].background,
      border: darkColors.filter((k) => k.category === "category42b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category42b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category42b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category42b")[0].color,
      size: darkColors.filter((k) => k.category === "category42b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category42b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "43bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category43b")[0].background,
      border: darkColors.filter((k) => k.category === "category43b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category43b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category43b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category43b")[0].color,
      size: darkColors.filter((k) => k.category === "category43b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category43b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "44bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category44b")[0].background,
      border: darkColors.filter((k) => k.category === "category44b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category44b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category44b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category44b")[0].color,
      size: darkColors.filter((k) => k.category === "category44b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category44b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "45bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category45b")[0].background,
      border: darkColors.filter((k) => k.category === "category45b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category45b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category45b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category45b")[0].color,
      size: darkColors.filter((k) => k.category === "category45b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category45b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "46bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category46b")[0].background,
      border: darkColors.filter((k) => k.category === "category46b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category46b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category46b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category46b")[0].color,
      size: darkColors.filter((k) => k.category === "category46b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category46b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "47bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category47b")[0].background,
      border: darkColors.filter((k) => k.category === "category47b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category47b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category47b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category47b")[0].color,
      size: darkColors.filter((k) => k.category === "category47b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category47b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "48bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category48b")[0].background,
      border: darkColors.filter((k) => k.category === "category48b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category48b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category48b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category48b")[0].color,
      size: darkColors.filter((k) => k.category === "category48b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category48b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //Health2

  "51bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category51b")[0].background,
      border: darkColors.filter((k) => k.category === "category51b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category51b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category51b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category51b")[0].color,
      size: darkColors.filter((k) => k.category === "category51b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category51b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "52bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category52b")[0].background,
      border: darkColors.filter((k) => k.category === "category52b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category52b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category52b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category52b")[0].color,
      size: darkColors.filter((k) => k.category === "category52b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category52b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "53bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category53b")[0].background,
      border: darkColors.filter((k) => k.category === "category53b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category53b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category53b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category53b")[0].color,
      size: darkColors.filter((k) => k.category === "category53b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category53b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "54bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category54b")[0].background,
      border: darkColors.filter((k) => k.category === "category54b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category54b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category54b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category54b")[0].color,
      size: darkColors.filter((k) => k.category === "category54b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category54b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "55bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category55b")[0].background,
      border: darkColors.filter((k) => k.category === "category55b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category55b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category55b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category55b")[0].color,
      size: darkColors.filter((k) => k.category === "category55b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category55b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "56bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category56b")[0].background,
      border: darkColors.filter((k) => k.category === "category56b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category56b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category56b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category56b")[0].color,
      size: darkColors.filter((k) => k.category === "category56b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category56b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "57bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category57b")[0].background,
      border: darkColors.filter((k) => k.category === "category57b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category57b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category57b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category57b")[0].color,
      size: darkColors.filter((k) => k.category === "category57b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category57b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "58bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category58b")[0].background,
      border: darkColors.filter((k) => k.category === "category58b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category58b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category58b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category58b")[0].color,
      size: darkColors.filter((k) => k.category === "category58b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category58b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //Fitness
  "61bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category61b")[0].background,
      border: darkColors.filter((k) => k.category === "category61b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category61b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category61b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category61b")[0].color,
      size: darkColors.filter((k) => k.category === "category61b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category61b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "62bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category62b")[0].background,
      border: darkColors.filter((k) => k.category === "category62b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category62b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category62b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category62b")[0].color,
      size: darkColors.filter((k) => k.category === "category62b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category62b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "63bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category63b")[0].background,
      border: darkColors.filter((k) => k.category === "category63b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category63b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category63b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category63b")[0].color,
      size: darkColors.filter((k) => k.category === "category63b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category63b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "64bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category64b")[0].background,
      border: darkColors.filter((k) => k.category === "category64b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category64b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category64b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category64b")[0].color,
      size: darkColors.filter((k) => k.category === "category64b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category64b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "65bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category65b")[0].background,
      border: darkColors.filter((k) => k.category === "category65b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category65b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category65b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category65b")[0].color,
      size: darkColors.filter((k) => k.category === "category65b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category65b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "66bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category66b")[0].background,
      border: darkColors.filter((k) => k.category === "category66b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category66b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category66b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category66b")[0].color,
      size: darkColors.filter((k) => k.category === "category66b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category66b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "67bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category67b")[0].background,
      border: darkColors.filter((k) => k.category === "category67b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category67b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category67b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category67b")[0].color,
      size: darkColors.filter((k) => k.category === "category67b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category67b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "68bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category68b")[0].background,
      border: darkColors.filter((k) => k.category === "category68b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category68b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category68b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category68b")[0].color,
      size: darkColors.filter((k) => k.category === "category68b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category68b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //Biometric
  "71bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category71b")[0].background,
      border: darkColors.filter((k) => k.category === "category71b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category71b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category71b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category71b")[0].color,
      size: darkColors.filter((k) => k.category === "category71b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category71b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "72bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category72b")[0].background,
      border: darkColors.filter((k) => k.category === "category72b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category72b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category72b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category72b")[0].color,
      size: darkColors.filter((k) => k.category === "category72b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category72b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "73bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category73b")[0].background,
      border: darkColors.filter((k) => k.category === "category73b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category73b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category73b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category73b")[0].color,
      size: darkColors.filter((k) => k.category === "category73b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category73b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "74bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category74b")[0].background,
      border: darkColors.filter((k) => k.category === "category74b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category74b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category74b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category74b")[0].color,
      size: darkColors.filter((k) => k.category === "category74b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category74b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "75bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category75b")[0].background,
      border: darkColors.filter((k) => k.category === "category75b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category75b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category75b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category75b")[0].color,
      size: darkColors.filter((k) => k.category === "category75b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category75b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "76bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category76b")[0].background,
      border: darkColors.filter((k) => k.category === "category76b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category76b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category76b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category76b")[0].color,
      size: darkColors.filter((k) => k.category === "category76b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category76b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "77bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category77b")[0].background,
      border: darkColors.filter((k) => k.category === "category77b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category77b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category77b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category77b")[0].color,
      size: darkColors.filter((k) => k.category === "category77b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category77b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "78bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category78b")[0].background,
      border: darkColors.filter((k) => k.category === "category78b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category78b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category78b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category78b")[0].color,
      size: darkColors.filter((k) => k.category === "category78b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category78b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
  //Location
  "81bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category81b")[0].background,
      border: darkColors.filter((k) => k.category === "category81b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category81b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category81b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category81b")[0].color,
      size: darkColors.filter((k) => k.category === "category81b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category81b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "82bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category82b")[0].background,
      border: darkColors.filter((k) => k.category === "category82b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category82b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category82b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category82b")[0].color,
      size: darkColors.filter((k) => k.category === "category82b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category82b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "83bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category83b")[0].background,
      border: darkColors.filter((k) => k.category === "category83b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category83b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category83b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category83b")[0].color,
      size: darkColors.filter((k) => k.category === "category83b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category83b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "84bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category84b")[0].background,
      border: darkColors.filter((k) => k.category === "category84b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category84b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category84b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category84b")[0].color,
      size: darkColors.filter((k) => k.category === "category84b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category84b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "85bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category85b")[0].background,
      border: darkColors.filter((k) => k.category === "category85b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category85b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category85b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category85b")[0].color,
      size: darkColors.filter((k) => k.category === "category85b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category85b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "86bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category86b")[0].background,
      border: darkColors.filter((k) => k.category === "category86b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category86b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category86b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category86b")[0].color,
      size: darkColors.filter((k) => k.category === "category86b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category86b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "87bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category87b")[0].background,
      border: darkColors.filter((k) => k.category === "category87b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category87b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category87b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category87b")[0].color,
      size: darkColors.filter((k) => k.category === "category87b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category87b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "88bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category88b")[0].background,
      border: darkColors.filter((k) => k.category === "category88b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category88b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category88b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category88b")[0].color,
      size: darkColors.filter((k) => k.category === "category88b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category88b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },

  //dataOwnerUploaded
  "91bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category91b")[0].background,
      border: darkColors.filter((k) => k.category === "category91b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category91b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category91b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category91b")[0].color,
      size: darkColors.filter((k) => k.category === "category91b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category91b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 10,
  },
  "92bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category92b")[0].background,
      border: darkColors.filter((k) => k.category === "category92b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category92b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category92b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category92b")[0].color,
      size: darkColors.filter((k) => k.category === "category92b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category92b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 9,
  },
  "93bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category93b")[0].background,
      border: darkColors.filter((k) => k.category === "category93b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category93b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category93b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category93b")[0].color,
      size: darkColors.filter((k) => k.category === "category93b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category93b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 8,
  },
  "94bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category94b")[0].background,
      border: darkColors.filter((k) => k.category === "category94b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category94b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category94b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category94b")[0].color,
      size: darkColors.filter((k) => k.category === "category94b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category94b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 7,
  },
  "95bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category95b")[0].background,
      border: darkColors.filter((k) => k.category === "category95b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category95b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category95b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category95b")[0].color,
      size: darkColors.filter((k) => k.category === "category95b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category95b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 6,
  },
  "96bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category96b")[0].background,
      border: darkColors.filter((k) => k.category === "category96b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category96b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category96b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category96b")[0].color,
      size: darkColors.filter((k) => k.category === "category96b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category96b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "97bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category97b")[0].background,
      border: darkColors.filter((k) => k.category === "category97b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category97b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category97b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category97b")[0].color,
      size: darkColors.filter((k) => k.category === "category97b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category97b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 4,
  },
  "98bgroup": {
    color: {
      background: darkColors.filter((k) => k.category === "category98b")[0].background,
      border: darkColors.filter((k) => k.category === "category98b")[0].border,
      highlight: {
        background: darkColors.filter((k) => k.category === "category98b")[0].background,
        border: "#FFFFFF",
      },
      hover: {
        background: darkColors.filter((k) => k.category === "category98b")[0].background,
        border: "#FFFFFF",
      },
    },
    borderWidth: 5,
    borderWidthSelected: 5,
    font: {
      color: darkColors.filter((k) => k.category === "category98b")[0].color,
      size: darkColors.filter((k) => k.category === "category98b")[0].fontSize,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: darkColors.filter((k) => k.category === "category98b")[0].bubbleSize,
    shape: "circle",
    margin: 2,
    mass: 3,
  },
};

// Network view demo user groups - added at end of file
export const NetworkUserGroups = {
  "networkUser": {
    color: {
      background: "#00bcd4",
      border: "#4dd0e1",
      highlight: {
        background: "#4dd0e1",
        border: "#FFFFFF",
      },
      hover: {
        background: "#4dd0e1",
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: "#FFFFFF",
      size: 11,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: 50,
    shape: "circle",
    margin: 2,
    mass: 5,
  },
  "networkCorp": {
    color: {
      background: "#ff9800",
      border: "#ffb74d",
      highlight: {
        background: "#ffb74d",
        border: "#FFFFFF",
      },
      hover: {
        background: "#ffb74d",
        border: "#FFFFFF",
      },
    },
    borderWidth: 2,
    borderWidthSelected: 3,
    font: {
      color: "#FFFFFF",
      size: 12,
      face: "Barlow",
      align: "center",
    },
    widthConstraint: 60,
    shape: "diamond",
    margin: 2,
    mass: 6,
  },
  "demoUserGlow": {
    shape: "dot",
    borderWidth: 0,
    font: {
      size: 0,
    },
    mass: 1,
    chosen: false,
  },
  "demoUser": {
    borderWidth: 0,
    font: {
      color: "#FFFFFF",
      size: 14,
      face: "Barlow",
      align: "center",
    },
    mass: 3,
  },
};
